import { useState, type FormEvent } from 'react';
import { Link } from 'react-router-dom';
import { useRedeemActivationCode } from '../hooks/api-hooks';
import { ErrorState } from '../components/States';

export function RedeemPage() {
  const [code, setCode] = useState('');
  const redeem = useRedeemActivationCode();

  function handleSubmit(event: FormEvent) {
    event.preventDefault();
    const trimmed = code.trim();
    if (trimmed) {
      redeem.mutate(trimmed, { onSuccess: () => setCode('') });
    }
  }

  function changeCode(nextCode: string) {
    setCode(nextCode);
    redeem.reset();
  }

  return (
    <section aria-labelledby="redeem-title">
      <h1 id="redeem-title">Kích hoạt khoá học</h1>
      <p className="muted" id="redeem-help">
        Nhập mã kích hoạt để nhận quyền truy cập. Mỗi mã chỉ dùng được một lần.
      </p>

      <form onSubmit={handleSubmit} className="inline-form" aria-busy={redeem.isPending}>
        <label htmlFor="code">Mã kích hoạt</label>
        <input
          id="code"
          value={code}
          onChange={(event) => changeCode(event.target.value)}
          autoComplete="off"
          spellCheck={false}
          required
          disabled={redeem.isPending}
          aria-describedby="redeem-help"
        />
        <button type="submit" disabled={redeem.isPending || !code.trim()}>
          {redeem.isPending ? 'Đang kích hoạt…' : 'Kích hoạt'}
        </button>
      </form>

      {redeem.error && <ErrorState error={redeem.error} />}
      {redeem.isSuccess && (
        <p className="success" role="status" aria-live="polite">
          Kích hoạt thành công. <Link to="/thu-vien">Mở thư viện</Link>.
        </p>
      )}
    </section>
  );
}
